import { ReactNode, forwardRef } from 'react';

import './style.less';

interface Props {
  children: ReactNode;
  selected?: boolean;
  onClick?: () => void;
  header?: ReactNode;
  isEtiquetteWhite?: boolean;
}

const EtiquetteCard = forwardRef<HTMLDivElement, Props>(
  ({ children, selected, onClick, header, isEtiquetteWhite = false }, ref) => {
    return (
      <div
        ref={ref}
        className="etiquette"
        data-selected={selected}
        data-etiquette-white={isEtiquetteWhite}
        onClick={onClick}
      >
        {header && <div className="etiquette-header">{header}</div>}

        {children}
      </div>
    );
  },
);

export default EtiquetteCard;
